import React from 'react';

export const ConfirmationDialog = ({isVisible, onConfirm, onCancel, message, confirmText, cancelText}) => {
	if (!isVisible) return null;
	const dialogStyle = {
		position: "fixed",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "white",
		padding: "20px",
		boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
		borderRadius: "8px",
		zIndex: 1000,
		textAlign: "center"
	};
	const overlayStyle = {
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		zIndex: 999
	};
	return (
			<div style={overlayStyle}>
				<div style={dialogStyle}>
					<p style={{marginBottom: "20px", fontSize: "20px", color: "#333"}}>
						{message.split('\n').map((line, index) => (
								<React.Fragment key={index}>
									{line}
									<br/>
								</React.Fragment>
						))}
					</p>
					<button
							style={{
								margin: "5px",
								padding: "10px 20px",
								backgroundColor: "#dc3545",
								color: "#fff",
								border: "none",
								borderRadius: "5px",
								cursor: "pointer"
							}}
							onClick={onCancel}>
						{cancelText}
					</button>
					<button
							style={{
								margin: "5px",
								padding: "10px 20px",
								backgroundColor: "#28a745",
								color: "#fff",
								border: "none",
								borderRadius: "5px",
								cursor: "pointer"
							}}
							onClick={onConfirm}>
						{confirmText}
					</button>
				</div>
			</div>
	);
};
